import { FrontOfficeAuthorizations } from 'shell/authorizations/front-office';

export const authsObj = Object.freeze({
  read: [FrontOfficeAuthorizations.CertificazioneRegistroQuery],
  create: [FrontOfficeAuthorizations.CertificazioneRegistroAdd],
  edit: [FrontOfficeAuthorizations.CertificazioneRegistroUpdate],
  delete: [FrontOfficeAuthorizations.CertificazioneRegistroDelete],
});
